import { useState } from "react";
import { api } from "api";
import { descargarCierreInventarioExcel } from "../../../../helpers/descargarCierreInventarioExcel";

const ENDPOINT = "prod_bodega_cierres_inventario";

export const CierresTabApi = () => {
    const [cargando, setCargando] = useState(false);

    const getCierres = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(ENDPOINT, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const abrirCierre = async () => {
        try {
            setCargando(true);
            const response = await api.post(ENDPOINT, {});
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // sin inventario inicial configurado no se puede cerrar, así que el
    // listado necesita saber si ya existe
    const getInventarioInicial = async () => {
        try {
            setCargando(true);
            const response = await api.get(
                "prod_bodega_inventario_inicial/actual",
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // cancela el cierre en proceso, también uno reabierto
    const cancelarCierre = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`${ENDPOINT}/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const reabrirCierre = async (id) => {
        try {
            setCargando(true);
            const response = await api.post(`${ENDPOINT}/${id}/reabrir`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const descargarCierreExcel = async (cierre) => {
        try {
            setCargando(true);
            await descargarCierreInventarioExcel(cierre);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getCierres,
        abrirCierre,
        getInventarioInicial,
        cancelarCierre,
        reabrirCierre,
        descargarCierreExcel,

        cargando,
    };
};
